module.exports = {
    'canvassers.index': 'canvassers',
    'canvassers.regions.index': 'canvassers/regions',
    'canvassers.sources.index': 'canvassers/sources',
    'canvasser.sources.show': 'canvassers/sources/$1',
};
